import {
  createPeekContent,
  PaymentSummaryContent,
} from "@/components/shared/relationships/peek-content";
import { registerPeekType } from "@/components/shared/relationships/peek-registry";
import { useCustomerPayment } from "@/features/customer-payments/hooks/use-customer-payments";

function CustomerPaymentContent({
  payment,
}: {
  payment: NonNullable<ReturnType<typeof useCustomerPayment>["data"]>;
}) {
  return (
    <PaymentSummaryContent
      payment={{
        accountId: payment.account_id,
        accountName: payment.gl_accounts?.name,
        amount: payment.amount,
        date: payment.date,
        id: payment.id,
        method: payment.method,
        reference: payment.reference,
        targetId: payment.invoice_id,
        targetLabel: "Invoice",
        targetName: payment.gl_invoices?.uid,
        targetType: "invoice",
        uid: payment.uid,
      }}
    />
  );
}

/** Customer-payment quick-view content, registered on import via `src/app/peek-registrations.ts`. */
export const CustomerPaymentPeekContent = createPeekContent({
  emptyMessage: "No payment found",
  render: (payment) => <CustomerPaymentContent payment={payment} />,
  useDetail: useCustomerPayment,
});

registerPeekType("customer-payment", CustomerPaymentPeekContent);
